module.exports = __webpack_public_path__ + "img/unionpay.d73d67e6.svg";